import React from "react";
import "../../styles/order-flow.css";

const offlineSteps = [
  {
    icon: "bi bi-geo-alt",
    text: "Datang langsung ke vendor Originality di Jln. Pati - Kudus Km.4 Gg. Desa Badegan, Kec. Margorejo, Kab. Pati, Jawa Tengah (59163).",
  },
  {
    icon: "bi bi-chat-dots",
    text: "Konsultasi dengan CS terkait desain, jenis bahan, type/model, harga, dan kebutuhan lainnya.",
  },
  {
    icon: "bi bi-receipt",
    text: "CS memberikan Invoice Order berisi detail pesanan (harga, jumlah, dll).",
  },
  {
    icon: "bi bi-search",
    text: "Cek pesanan: desain, ukuran, type/model, jumlah, dan bahan.",
  },
  {
    icon: "bi bi-wallet2",
    text: "Lakukan pembayaran / DP 70% (CS atau Transfer Bank).",
  },
  { icon: "bi bi-gear", text: "Proses produksi sesuai waktu dan ketentuan." },
  {
    icon: "bi bi-check2-circle",
    text: "Finishing, Quality Control, dan Packing.",
  },
  {
    icon: "bi bi-truck",
    text: "Pesanan dikirim atau diambil langsung di vendor.",
  },
];

const onlineSteps = [
  {
    icon: "bi bi-whatsapp",
    text: "Hubungi admin melalui WhatsApp: 081 272 800 800.",
  },
  {
    icon: "bi bi-chat-left-text",
    text: "Konsultasi dengan CS terkait desain, jenis bahan, type/model, harga, dan kebutuhan lainnya.",
  },
  {
    icon: "bi bi-receipt",
    text: "CS memberikan Invoice Order berisi detail pesanan (harga, jumlah, dll).",
  },
  {
    icon: "bi bi-search",
    text: "Cek pesanan: desain, ukuran, type/model, jumlah, dan bahan.",
  },
  {
    icon: "bi bi-credit-card",
    text: "Lakukan pembayaran / DP 70% (CS atau Transfer Bank).",
  },
  { icon: "bi bi-gear", text: "Proses produksi sesuai waktu dan ketentuan." },
  {
    icon: "bi bi-shield-check",
    text: "Finishing, Quality Control, dan Packing.",
  },
  {
    icon: "bi bi-truck",
    text: "Pesanan dikirim atau diambil langsung di vendor.",
  },
];

export default function OrderFlow() {
  return (
    <section className="order-flow-section py-5">
      <div className="container" data-aos="fade-up">
        <h2 className="text-center fw-bold mb-4">Alur Pemesanan</h2>

        {/* Tabs */}
        <ul className="nav nav-tabs justify-content-center mb-4" role="tablist">
          <li className="nav-item">
            <button
              className="nav-link active"
              data-bs-toggle="tab"
              data-bs-target="#offline"
              data-aos-delay="100"
            >
              Offline
            </button>
          </li>
          <li className="nav-item">
            <button
              className="nav-link"
              data-bs-toggle="tab"
              data-bs-target="#online"
              data-aos-delay="100"
            >
              Online
            </button>
          </li>
        </ul>

        <div className="tab-content">
          {/* OFFLINE */}
          <div className="tab-pane fade show active" id="offline">
            <div className="flow-grid">
              {offlineSteps.map((step, index) => (
                <div
                  className="flow-item"
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="flow-icon">
                    <i className={step.icon} />
                    <span className="flow-number">{index + 1}</span>
                  </div>
                  <p>{step.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* ONLINE */}
          <div className="tab-pane fade" id="online">
            <div className="flow-grid">
              {onlineSteps.map((step, index) => (
                <div className="flow-item" key={index} data-aos="fade-up">
                  <div className="flow-icon">
                    <i className={step.icon} />
                    <span className="flow-number">{index + 1}</span>
                  </div>
                  <p>{step.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
